var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bigtitle",class:{'mClass': _vm.mClass}},[_vm._v("\n\t"+_vm._s(_vm.bigtitle.CHN)),_c('span',[_vm._v(_vm._s(_vm.bigtitle.ENG))])])
}
var staticRenderFns = []

export { render, staticRenderFns }